(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scent-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scent-description')) {
    class ScentDescription extends HTMLElement {
      connectedCallback() {
        const scope = this.closest('.shopify-section') || document;
        const picker = scope.querySelector('scent-picker');
        if (picker && picker.current !== undefined) this.show(picker.current);
      }

      show(key) {
        const target = String(key);
        let found = false;
        this.querySelectorAll('.scent-description__panel').forEach((panel) => {
          const match = panel.dataset.key === target;
          if (panel.hidden === match) panel.hidden = !match;
          if (match) found = true;
        });
        if (this.hidden === found) this.hidden = !found;
      }
    }

    customElements.define('scent-description', ScentDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scent-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scent-picker')) {
    class ScentPicker extends HTMLElement {
      // Remembers the chosen scent per product, so a theme re-render can't reset it.
      static memory = new Map();

      connectedCallback() {
        this.section = this.closest('.shopify-section') || document.body;
        this.key = this.dataset.productId || 'default';
        this.optionIndex = Number(this.dataset.optionIndex);

        const json = this.querySelector('script[data-scent-variants]');
        try {
          this.variants = json ? JSON.parse(json.textContent) : [];
        } catch (error) {
          this.variants = [];
        }

        if (!ScentPicker.memory.has(this.key)) {
          const pressed = this.querySelector('.scent-picker__button[aria-pressed="true"]');
          const first = this.querySelector('.scent-picker__button');
          ScentPicker.memory.set(this.key, (pressed || first)?.dataset.key || '0');
        }

        this.addEventListener('click', this.handleClick);

        this.observer = new MutationObserver(() => this.scheduleSync());
        this.observer.observe(this.section, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['aria-pressed'],
        });

        this.sync();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.observer?.disconnect();
        if (this.pending) cancelAnimationFrame(this.pending);
      }

      get current() {
        return ScentPicker.memory.get(this.key) || '0';
      }

      get currentButton() {
        return this.querySelector(`.scent-picker__button[data-key="${this.current}"]`);
      }

      handleClick = (event) => {
        const button = event.target.closest('.scent-picker__button');
        if (!button) return;
        const key = button.dataset.key;
        if (key === this.current) return;

        ScentPicker.memory.set(this.key, key);
        this.sync();

        if (this.dataset.mode === 'variant' && this.dataset.syncNative === 'true') {
          this.clickNativeOption();
        }
      };

      scheduleSync() {
        if (this.pending) return;
        this.pending = requestAnimationFrame(() => {
          this.pending = null;
          this.sync();
        });
      }

      sync() {
        const key = this.current;

        this.querySelectorAll('.scent-picker__button').forEach((button) => {
          const value = String(button.dataset.key === key);
          if (button.getAttribute('aria-pressed') !== value) button.setAttribute('aria-pressed', value);
        });

        const label = this.querySelector('.scent-picker__selected');
        const text = this.currentButton?.textContent.trim() || '';
        if (label && label.textContent !== text) label.textContent = text;

        if (this.dataset.mode === 'variant') {
          this.applyVariant(key);
        } else {
          this.syncCartProperty();
        }

        this.section.querySelectorAll('scent-description').forEach((el) => el.show?.(key));
      }

      get forms() {
        return [...this.section.querySelectorAll('form[action*="/cart/add"]')];
      }

      findTarget(key) {
        if (!this.variants.length || this.optionIndex < 0) return null;
        const scent = Number(key);
        const idInput = this.section.querySelector('form[action*="/cart/add"] [name="id"]');
        const currentId = Number(idInput?.value);
        const base = this.variants.find((v) => v.id === currentId) || this.variants[0];
        const index = this.optionIndex;

        return (
          this.variants.find(
            (v) => v.scent === scent && v.options.every((o, i) => i === index || o === base.options[i])
          ) || this.variants.find((v) => v.scent === scent)
        );
      }

      applyVariant(key) {
        const target = this.findTarget(key);
        if (!target) return;
        const id = String(target.id);

        this.forms.forEach((form) => {
          form.querySelectorAll('[name="id"]').forEach((input) => {
            if (input.value !== id) input.value = id;
          });
          form.querySelectorAll('button[type="submit"], [name="add"]').forEach((button) => {
            if (button.disabled === target.available) button.disabled = !target.available;
          });
        });

        this.section.querySelectorAll('sticky-add-to-cart').forEach((el) => {
          if (el.dataset.currentVariantId !== id) el.dataset.currentVariantId = id;
        });

        this.checkNativeOption(target);

        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== id) {
          url.searchParams.set('variant', id);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      // The theme's own variant picker, found by position (not by name), so it works in every language.
      findNativeOption() {
        const fieldsets = [...this.section.querySelectorAll('variant-picker fieldset')];
        return fieldsets[this.optionIndex] || null;
      }

      checkNativeOption(target) {
        const option = this.findNativeOption();
        if (!option) return;
        const wanted = target.options[this.optionIndex];

        const radio = [...option.querySelectorAll('input[type="radio"]')].find((input) => input.value === wanted);
        if (radio && !radio.checked) radio.checked = true;

        const select = option.querySelector('select');
        if (select) {
          const match = [...select.options].find((opt) => opt.value === wanted || opt.textContent.trim() === wanted);
          if (match && select.value !== match.value) select.value = match.value;
        }
      }

      clickNativeOption() {
        const option = this.findNativeOption();
        if (!option) return;
        const checked = option.querySelector('input[type="radio"]:checked');
        if (checked) {
          checked.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const select = option.querySelector('select');
        if (select) select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Products without a scent variant: the chosen scent is saved on the cart line (always in English for your orders).
      syncCartProperty() {
        const value = this.currentButton?.dataset.en || '';
        this.forms.forEach((form) => {
          let input = form.querySelector('input[data-scent-property]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.dataset.scentProperty = '';
            input.name = 'properties[Scent]';
            form.appendChild(input);
          }
          if (input.value !== value) input.value = value;
        });
      }
    }

    customElements.define('scent-picker', ScentPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
